import { useQuery } from "@tanstack/react-query";
import { userService } from "@/features/users/services/userService";
import { queryKeys } from "@/lib/query-keys";
import type { ListUsersQuery } from "@/types/user";

export function useUsers(filters?: ListUsersQuery) {
  return useQuery({
    queryKey: queryKeys.users.list(filters),
    queryFn: () => userService.list(filters),
  });
}

export function useUser(id: string) {
  return useQuery({
    queryKey: queryKeys.users.detail(id),
    queryFn: () => userService.get(id),
    enabled: !!id,
  });
}

export function useUserActivity(
  id: string,
  query?: { page?: number; limit?: number },
  enabled = true,
) {
  return useQuery({
    queryKey: [...queryKeys.users.detail(id), "activity", query],
    queryFn: () => userService.activity(id, query),
    enabled: !!id && enabled,
  });
}
